import 'ng-file-upload/dist/ng-file-upload-shim';
import 'ng-file-upload/dist/ng-file-upload-all';

export default angular.module('ui.cian.ng-file-upload.adapter', ['ngFileUpload'])
	.name;
